export class ObjectUtil {
    static isBooleanValid(value): boolean {
        return value === true || value === false;
    }

    static isEmpty(value): boolean {
        return value === '' || typeof value === 'undefined' || value === null;
    }

    static isNotEmpty(value): boolean {
        return !ObjectUtil.isEmpty(value);
    }

    static clone(obj: any) {
        return JSON.parse(JSON.stringify(obj));
    }
}
